"use client";

import { useLocale, useLocalizedData } from "@/context/LocaleContext";
import { I18nData } from "@/types/i18n";
import { useMemo } from "react";
import "./language-switcher.scss";

interface LanguageSwitcherProps {
  i18nData?: I18nData;
}

export default function LanguageSwitcher({ i18nData }: LanguageSwitcherProps) {
  const { locale, setLocale, availableLocales } = useLocale();
  const localizedData = useLocalizedData(i18nData);

  const selectLanguageText = useMemo(() => {
    return localizedData?.select_language || "Select language";
  }, [localizedData]);

  // Don't render if only one locale is available
  if (availableLocales.length <= 1) {
    return null;
  }

  return (
    <div className="language-switcher">
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        aria-label={selectLanguageText || "Select language"}
        title={localizedData?.language_selector_tooltip || "Change language"}
      >
        {availableLocales.map((loc) => (
          <option key={loc} value={loc}>
            {i18nData?.[loc]?.name || loc.toUpperCase()}
          </option>
        ))}
      </select>
    </div>
  );
}
